import { ScreenOverlay } from "@/components/overlay/screen";
import { css, keyframes } from "@/domains/emotion";
import { FC } from "react";
import memLogomarkImage from "@/assets/images/logomark.svg";
import { ZIndex } from "@/domains/design/constants";
import { AnimatePresence, motion } from "motion/react";

interface LoadingOverlayProps {
  isVisible: boolean;
}

export const LoadingOverlay: FC<LoadingOverlayProps> = ({ isVisible }) => {
  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ delay: 0.05, duration: 0.2 }}
          className={overlayStyles}
        >
          <ScreenOverlay>
            <motion.img
              src={memLogomarkImage}
              className={loaderStyles}
              animate={{ scale: [1, 1.05, 1] }}
              transition={{
                duration: 1,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            />
          </ScreenOverlay>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

const overlayStyles = css({
  position: "absolute",
  zIndex: ZIndex.ScreenOverlay,
});

const pulseAnimation = keyframes({
  from: {
    transform: "scale3d(1, 1, 1)",
  },
  "50%": {
    transform: "scale3d(1.05, 1.05, 1.05)",
  },
  to: {
    transform: "scale3d(1, 1, 1)",
  },
});

const loaderStyles = css({
  width: 48,
  height: 48,
  position: "absolute",
  top: "50%",
  left: "50%",
  marginTop: -24,
  marginLeft: -24,
  zIndex: -1,
  animation: `1s ${pulseAnimation} infinite`,
});
